import { Breadcrumbs } from '@mui/material';
import QUERY_KEYS from 'network/config/queryKeys';
import { getAllCategories } from 'network/services/goods';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CrumbIcon } from '../../assets/Icons';
import { Spacer } from '../../components/atoms';
import { FilterBadges, SortBy } from '../../components/molecules';
import replacer from '../../utils/replacer';
import { ProductSkeletons } from '../Products';

import VendorsCategoriesWithFilters from 'components/molecules/m-vendors-categories/VendorsCategoriesWithFilters';
import ProductsByVendor from './ProductsByVendor';
import { FilterWrapper, HeaderCon, HeaderLink, SortWrapper } from './style';

export const VendorsByCategories = () => {
  const [sort, setSort] = useState('product-rating');
  const [filters, setFilters] = useState({
    bestsellers: false,
    promotions: false
  });
  const [searchParams] = useSearchParams();
  const vendorParam = searchParams.get('vendor');
  const vendorId = vendorParam ? parseInt(vendorParam) : undefined;
  const navigate = useNavigate();
  const { category, sub_category } = useParams();
  const parsed_category = category ? replacer(/-/g, ' ', category) : 'Supermarket';
  const parsed_sub_category = replacer(/-/g, ' ', sub_category);

  const { data: categories, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_CATEGORIES, vendorId],
    queryFn: () => getAllCategories(vendorId),
    enabled: !vendorId,
    staleTime: 1000 * 60 * 60
  });

  return (
    <div>
      <HeaderCon sub={!!sub_category}>
        {sub_category ? (
          <>
            <Breadcrumbs aria-label="breadcrumb" separator={<CrumbIcon />}>
              <HeaderLink onClick={() => navigate(`/${category}`)}>{parsed_category} Vendors</HeaderLink>
              <HeaderLink>{parsed_sub_category}</HeaderLink>
            </Breadcrumbs>
            <div className="flex flex-row gap-0 items-center justify-between w-full mt-2">
              <FilterWrapper>
                <FilterBadges filters={filters} setFilters={setFilters} />
              </FilterWrapper>
              <SortWrapper>
                <SortBy sort={sort} setSort={setSort} />
              </SortWrapper>
            </div>
          </>
        ) : (
          !vendorId && (
            <>
              <div>
                <HeaderLink>{parsed_category} Vendors</HeaderLink>
              </div>
              <div className="flex flex-row gap-0 items-center justify-between w-full">
                <FilterWrapper>
                  <FilterBadges filters={filters} setFilters={setFilters} />
                </FilterWrapper>
                <SortWrapper>
                  <SortBy sort={sort} setSort={setSort} />
                </SortWrapper>
              </div>
            </>
          )
        )}
      </HeaderCon>
      {vendorId ? (
        <ProductsByVendor />
      ) : (
        (categories ?? []).length > 0 && <VendorsCategoriesWithFilters sort={sort} filters={filters} />
      )}
      {!vendorId && isLoading && (
        <div className="grid bg-white rounded-md grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <ProductSkeletons count={20} />
        </div>
      )}
      <Spacer height={'4rem'} />
    </div>
  );
};
